import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { onFlyoutClicked, onInvalidVinData, onSelectionMethodChanged, onValidVinData, onVinUpdated } from '../actions';
import { VehicleSelection } from '../components';
import { getSelectedInfoEntries, getVehicleInfoData } from '../selectors';
export const UnboundVehicleSelectionContainer = (props) => {
    return (React.createElement(VehicleSelection, { vehicleInfoData: props.vehicleInfoData, selectedInfoEntries: props.selectedInfoEntries, isDisabled: props.isDisabled, shouldShowManualOption: props.shouldShowManualOption, onSelectionMethodChanged: props.onSelectionMethodChanged, onFlyoutClicked: props.onFlyoutClicked, onInvalidVinData: props.onInvalidVinData, onValidVinData: props.onValidVinData, onVinUpdated: props.onVinUpdated }));
};
const mapStateToProps = (state) => ({
    vehicleInfoData: getVehicleInfoData(state),
    selectedInfoEntries: getSelectedInfoEntries(state)
});
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ onSelectionMethodChanged, onFlyoutClicked, onValidVinData, onInvalidVinData, onVinUpdated }, dispatch);
};
export const VehicleSelectionContainer = connect(mapStateToProps, mapDispatchToProps)(UnboundVehicleSelectionContainer);
export default VehicleSelectionContainer;
//# sourceMappingURL=VehicleSelectionContainer.js.map